module.exports = __webpack_public_path__ + "assets/img/skin_4.563a9b6b.jpg";